'use client';
import { RoundedSectionCard } from '@/components/common/RoundedSectionCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { faArrowUpRightFromSquare, faLock } from '@fortawesome/pro-duotone-svg-icons';
import Button from '@/components/common/Button';
import Link from 'next/link';
import { getSourcePath } from '@/rewrites';

const TenderDataAccessNotice = () => {
  return (
    <RoundedSectionCard>
      <div className="flex justify-between">
        <div className="flex ">
          <span className="h-6 w-6 items-center justify-center">
            <FontAwesomeIcon className="h-6 w-6" icon={faLock} />
          </span>
          <div className="ml-2 text-2xl font-normal">Eingeschränkter Zugriff</div>
        </div>
        <div>
          <Link href={getSourcePath('/subscription')}>
            <Button label="Upgrade" icon={faArrowUpRightFromSquare} variant="secondary" titleClassName="text-base" />
          </Link>
        </div>
      </div>
      <div className="mt-2">
        Um die vollständigen Daten archivierter Ausschreibung zu sehen, ist ein kostenpflichtiges Abonnement
        erforderlich.
      </div>
    </RoundedSectionCard>
  );
};
export default TenderDataAccessNotice;
